import { alpha, type Theme, type ThemeOptions } from '@mui/material/styles';

/** MUI puts `MuiSwitch-color*` on switchBase; all DS switches use `color="secondary"`. */
function switchBaseColorStyles(trackColor: string) {
  return {
    '&.Mui-checked': {
      '&:hover': {
        backgroundColor: alpha(trackColor, 0.08)
      },
      '& + .MuiSwitch-track': {
        backgroundColor: trackColor,
        opacity: 1
      }
    },
    '&.Mui-disabled.Mui-checked': {
      '& + .MuiSwitch-track': {
        backgroundColor: alpha(trackColor, 0.38),
        opacity: 1
      }
    }
  };
}

export function switchThemeComponents(theme: Theme): ThemeOptions['components'] {
  const uncheckedTrack = theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[400];
  const trackColor = theme.palette.secondary.main;

  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          '&.SmSwitch-root': {
            padding: theme.spacing(1),
            '& .MuiSwitch-track': {
              borderRadius: 15,
              backgroundColor: uncheckedTrack,
              opacity: 1
            },
            '& .MuiSwitch-thumb': {
              borderRadius: '50%',
              backgroundColor: theme.palette.common.white,
              boxShadow: theme.shadows[1]
            },
            '& .MuiSwitch-switchBase.MuiSwitch-colorSecondary': switchBaseColorStyles(trackColor)
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '&.SmSwitch-formLabel': {
            margin: 0,
            gap: theme.spacing(0.5),
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: '13px',
              fontWeight: 600,
              lineHeight: 1.5,
              color: theme.palette.text.primary,
              userSelect: 'none'
            },
            '&.Mui-disabled .MuiFormControlLabel-label': {
              color: theme.palette.text.disabled
            }
          }
        }
      }
    }
  };
}
